import TableCell from "components/Table/Cell";
import ProgressBar from "ds/components/ProgressBar";

import { LaunchPadTrackUserProgress } from "../types";
import { LAUNCHPAD_TRACK_COLUMN_ID } from "../constants";

type LaunchPadTrackMissionsProgressCellProps = {
  user: Pick<LaunchPadTrackUserProgress, "percentage">;
};

const LaunchPadTrackMissionsProgressCell = ({ user }: LaunchPadTrackMissionsProgressCellProps) => (
  <TableCell id={LAUNCHPAD_TRACK_COLUMN_ID.MISSIONS_PROGRESS}>
    <ProgressBar
      current={user.percentage}
      max={100}
      isPercentage
      fullWidth
      ariaLabel="Missions progress"
    />
  </TableCell>
);

export default LaunchPadTrackMissionsProgressCell;
